import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dlc3tm53ak: FaireBrandEntity = {
  token: "b_dlc3tm53ak",
  type: "brand",
  name: "Grade & Gather",
  avatarUrl:
    "https://cdn.faire.com/fastly/1199730008ec01f6573989474924e2fd1092940afe240698a6cff861ef3b85ad.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6ab0829aaddd115531bca3a9d6987732ddde1794bcc5bf514e55e443089ac988.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1199730008ec01f6573989474924e2fd1092940afe240698a6cff861ef3b85ad.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6ab0829aaddd115531bca3a9d6987732ddde1794bcc5bf514e55e443089ac988.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 249,
  isInsider: true,
  description:
    "Grade and Gather was born from a quiet belief: that clothing should be both thoughtful and practical.\nWe design with the rhythm of life in mind—pieces that move gently through seasons of life.\nOur name reflects this sentiment: to grade is to refine, and to gather is to choose with care.\n\n*More selections available only at www.gradeandgather.com\n*Be our guest!\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:49.205Z",
    importedBy: "entity-db-cli",
  },
};
